
import CryptoJS from 'crypto-js/crypto-js'
const iv = CryptoJS.enc.Utf8.parse("37fa77f6a3b0462d");//十六位十六进制数作为密钥偏移量
// 解密方法
function Decrypt(word, key) {
    let decrypt = CryptoJS.AES.decrypt(word, CryptoJS.enc.Utf8.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt)
}
 
// 加密方法
function Encrypt(word, key) {
    let encrypted = CryptoJS.AES.encrypt(word, CryptoJS.enc.Utf8.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC, 
      padding: CryptoJS.pad.Pkcs7 
    });
    return encrypted.ciphertext.toString()
}
export default {
  Decrypt,
  Encrypt
}